import {
  DatePicker,
  Dropdown,
  IDropdownOption,
  Label,
  PrimaryButton,
  Separator,
  Spinner,
  SpinnerSize,
  Stack,
  TextField,
  Toggle
} from '@fluentui/react';
import { useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { getTokenAndListInfo, japaneseDateConverter, phoneNumFormat, useSmartBack, validatePhone } from '../../utils/item-helper';
import { GlobalVars, japaneseStrings, listname } from '../../constants/global-values';
import { common, formatMessage } from '../../messages/common-items';
import { personalInformation } from '../../messages/personal-Information';
import { addItem } from '../../services/graph-service';
import FileUpload from '../../components/file-upload';
import { BLOOD_TYPE_OPTIONS, EMERGENCY_RELATION_OPTIONS, GENDER_OPTIONS, JOBTYPE_OPTIONS, QUALIFICATION_OPTIONS } from '../../constants/options';

export default function AdminRegistrationPage() {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [errors, setErrors] = useState<any>({});
  const goBack = useSmartBack("/");
  type phoneNumberField = "PhoneNumber" | "EmergencyPhone";
  type DateField = "DateOfBirth" | "HealthCheckDate" | "QualificationExpiry";

  const [selectedDate, setSelectedDate] = useState<Record<DateField, Date | null>>({
    DateOfBirth: null,
    HealthCheckDate: null,
    QualificationExpiry: null
  });
  type QualificationData = {
    file?: File | null;
    QualificationExpiry?: Date | null;
  };
  const digits = GlobalVars.phoneNumber_enter.replace(/\D/g, "").slice(0, 11);
  const [selectedQualificationDate, setQualificationDate] = useState<Record<string, QualificationData>>({});
  const [selectedQualification, setSelectedQualification] = useState<string[]>([]);
  const [selectedItems, setSelectedItems] = useState<Record<string, string[]>>({});
  const formattedPhoneNum = phoneNumFormat(digits);
  const [phoneNumber, setPhoneNumber] = useState<Record<phoneNumberField, string>>({
    PhoneNumber: formattedPhoneNum || "",
    EmergencyPhone: ""
  });
  const { Labels: Lbl_Common, SuccessMessages: Success_Common, ErrorMessages: Err_Common } = common;
  const { Labels: Lbl_Personal_Info, SuccessMessages: Success_Personal_Info } = personalInformation;
  const location = useLocation();
  const mode = location.state?.mode || "register"; // "bulk-edit" or "register"
  const isBulkEdit = mode === "bulk-edit";
  const handleChange = (field: string, value: any) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev: any) => ({ ...prev, [field]: "" }));
  };
  const handleQualificationChange = (_: any, option?: IDropdownOption) => {
    if (!option) return;
    const key = option.key as string;
    let selectedQualifi = [...selectedOptions];
    if (option.selected) {
      selectedQualifi.push(option.text);
    } else {
      selectedQualifi = selectedQualifi.filter(item => item !== option.text);
    }
    setSelectedOptions(selectedQualifi);
    setSelectedQualification((prev) => {
      const exists = prev.includes(key);
      const updated = exists ? prev.filter((k) => k !== key) : [...prev, key];
      if (exists) {
        const updatedRisks = { ...selectedItems };
        delete updatedRisks[key];
        setSelectedItems(updatedRisks);
      }
      return updated;
    });
  };
  const [formData, setFormData] = useState({
    // Title: "Company A",
    Name: "",
    DateOfBirth: null,
    Gender: "",
    Address: "",
    PhoneNumber: GlobalVars.phoneNumber_enter || "",
    EmergencyPhone: "",
    EmergencyName: "",
    EmergencyRelation: "",
    IsSoleProprietor: "",
    SpecialLaborInsurance: "",
    BloodType: "",
    HealthCheckDate: null,
    JobType: "",
    // Qualifications: [],
    QualificationExpiry: null,
    CertificatePhotos: "",
    FacePhotos: "",
  });
  const [loading, setLoading] = useState(false);
  const validateAndSubmit = () => {

    const newErrors: any = {};
    if (!formData.Name.trim())
      newErrors.Name = formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.NAME);
    if (!formData.Gender?.trim()) {
      newErrors.Gender = formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.GENDER);
    }
    if (!formData.Address?.trim()) {
      newErrors.Address = formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.ADDRESS);
    }
    if (!formData.PhoneNumber.trim()) {
      newErrors.PhoneNumber = formatMessage(Err_Common.REQUIRED_VALUE, Success_Personal_Info.PHONE_VALID);
    } else if (!(validatePhone(formData.PhoneNumber))) {
      newErrors.PhoneNumber = formatMessage(Err_Common.INVALID_PHONE_ERR);
    }
    if (!formData.EmergencyPhone?.trim()) {
      newErrors.EmergencyPhone = formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.EMERGENCY_PHONENUMBER_LBL);
    } else if (!validatePhone(formData.EmergencyPhone)) {
      newErrors.EmergencyPhone = formatMessage(Err_Common.INVALID_PHONE_ERR);
    }
    if (!formData.EmergencyName?.trim()) {
      newErrors.EmergencyName = formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.EMERGENCY_NAME);
    }
    if (!formData.JobType?.trim()) {
      newErrors.JobType = formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.JOB_TYPE);
    }
    setErrors(newErrors);
    const firstErrorKey = Object.keys(newErrors)[0];
    if (firstErrorKey) {
      const el = document.getElementById(firstErrorKey);
      if (el) (el as HTMLInputElement).focus();
      return;
    }
    return Object.keys(newErrors).length === 0;
  };

  const handleQualificationsChange = (
    event: React.FormEvent<HTMLDivElement>,
    option?: IDropdownOption
  ) => {
    if (!option) return;
    let updated = [...selectedOptions];
    if (option.selected) {
      updated.push(option.text);
    } else {
      updated = updated.filter(item => item !== option.text);
    }
    setSelectedOptions(updated);
    handleChange("Qualifications", updated);
  };

  const handleSave = async () => {
    const { token, siteId, listId } = await getTokenAndListInfo(instance, listname);
    const newItem = await addItem(token, siteId, listId, formData);
    GlobalVars.userid = newItem.id;
    setLoading(false);
    navigate(`/shokai/tourokumsg`, { state: { from: "editshokai" } });
  };
  if (loading || !formData) {
    return <div className="loadercommon-container">
      <Spinner label={Success_Common.LOADER_MSG} size={SpinnerSize.large} />
    </div>;
  }
  const handlePhoneNumberChange = (
    field: 'PhoneNumber' | 'EmergencyPhone',
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const input = event.currentTarget.value;
    const digits = input.replace(/\D/g, '').slice(0, 11);

    let formattedPhoneNum = phoneNumFormat(digits);
    setPhoneNumber(prev => ({
      ...prev,
      [field]: formattedPhoneNum,
    }));
    const numFormat = formattedPhoneNum.replace(/-/g, "");
    handleChange(field, numFormat);
  };
  const SectionHeader: React.FC<{ title: string }> = ({ title }) => (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 10 }}>
      <Label styles={{ root: { whiteSpace: "nowrap", marginLeft: 15 } }}>{title}</Label>
      <Separator styles={{ root: { flexGrow: 1 } }} />
    </Stack>
  );

  return (
    <div className="background  list-background">
      <div className="form-container list-box">
        <div className="new-form-container">
          <h2>{isBulkEdit ? Lbl_Common.BULKEDIT : Lbl_Personal_Info.ADD}</h2>
          <Stack tokens={{ childrenGap: 16 }}>
            <SectionHeader title={Lbl_Personal_Info.BASIC_INFO_LBL} />
            <TextField
              id="Name"
              label={Lbl_Personal_Info.NAME}
              placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.NAME)}
              required
              type="text"
              onRenderInput={(props) => (
                <input {...props} inputMode="text" pattern="[A-Za-z ]*" />
              )}
              onChange={(_, val) => handleChange("Name", val)}
              errorMessage={errors.Name}
              autoComplete="name"
              inputMode="text" />
            <DatePicker
              label={Lbl_Personal_Info.DATEOFBIRTH}
              strings={japaneseStrings}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.DATEOFBIRTH)}
              value={selectedDate.DateOfBirth || undefined}
              onSelectDate={(date) => {
                const selDate = date || null;
                setSelectedDate((prev) => ({
                  ...prev,
                  DateOfBirth: selDate,
                }));
                handleChange("DateOfBirth", date);
              }}
              formatDate={japaneseDateConverter} />
            <Dropdown
              label={Lbl_Personal_Info.GENDER}
              id="Gender"
              required
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.GENDER)}
              options={GENDER_OPTIONS}
              onChange={(_, option) => handleChange("Gender", option?.text)}
              errorMessage={errors.Gender} />
            <TextField
              label={Lbl_Personal_Info.ADDRESS}
              required
              placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.ADDRESS)}
              id="Address"
              onChange={(_, val) => handleChange("Address", val)} errorMessage={errors.Address} />
            <TextField
              label={Lbl_Personal_Info.PHONENUMBER}
              required
              id="PhoneNumber"
              onChange={(e) => handlePhoneNumberChange("PhoneNumber", e)}
              type="tel"
              value={phoneNumber.PhoneNumber}
              maxLength={13}
              autoComplete="tel"
              placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.PHONENUMBER)}
              errorMessage={errors.PhoneNumber}
            />
            <SectionHeader title={Lbl_Personal_Info.EMERGENCY_PHONENUMBER_LBL} />
            <TextField
              required
              label={Lbl_Personal_Info.EMERGENCY_PHONENUMBER_LBL}
              placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.EMERGENCY_PHONENUMBER_LBL)}
              id="EmergencyPhone"
              type="tel"
              value={phoneNumber.EmergencyPhone}
              onChange={(e) => handlePhoneNumberChange("EmergencyPhone", e)}
              maxLength={13}
              autoComplete="tel"
              errorMessage={errors.EmergencyPhone} />
            <TextField
              required
              label={Lbl_Personal_Info.EMERGENCY_NAME}
              autoComplete="name"
              inputMode="text"
              placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.EMERGENCY_NAME)}
              id="EmergencyName"
              onChange={(_, val) => handleChange("EmergencyName", val)}
              errorMessage={errors.EmergencyName} />
            <Dropdown
              label={Lbl_Personal_Info.EMERGENCY_RELATION}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.EMERGENCY_RELATION)}
              id="EmergencyRelation"
              options={EMERGENCY_RELATION_OPTIONS}
              onChange={(_, o) => handleChange("EmergencyRelation", o?.text)} />
            <Toggle
              label={Lbl_Personal_Info.IS_SOLE_PROPRIETOR}
              checked={formData.IsSoleProprietor === Lbl_Personal_Info.YES_OPTION}
              onChange={(_, checked) =>
                handleChange("IsSoleProprietor", checked ? Lbl_Personal_Info.YES_OPTION : Lbl_Personal_Info.NO_OPTION)
              } />
            <Toggle
              label={Lbl_Personal_Info.SPECIAL_LABOR_INSURANCE}
              checked={formData.SpecialLaborInsurance === Lbl_Personal_Info.YES_OPTION}
              onChange={(_, checked) =>
                handleChange("SpecialLaborInsurance", checked ? Lbl_Personal_Info.YES_OPTION : Lbl_Personal_Info.NO_OPTION)
              } />
            <TextField
              label={Lbl_Personal_Info.PARTNER_COMPANY_LBL}
              placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.PARTNER_COMPANY_LBL)}
              id="PartnerName"
              onChange={(_, val) => handleChange("PartnerName", val)} errorMessage={errors.PartnerName} />
            <SectionHeader title={Lbl_Personal_Info.HEALTH_INFO_LBL} />
            <Dropdown
              label={Lbl_Personal_Info.BLOOD_TYPE}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.BLOOD_TYPE)}
              id="BloodType"
              options={BLOOD_TYPE_OPTIONS}
              onChange={(_, o) => handleChange("BloodType", o?.text)} />
            <DatePicker
              label={Lbl_Personal_Info.HEALTH_CHECK_DATE}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.HEALTH_CHECK_DATE)}
              strings={japaneseStrings}
              value={selectedDate.HealthCheckDate || undefined}
              onSelectDate={(date) => {
                const selDate = date || null;
                setSelectedDate((prev) => ({
                  ...prev,
                  HealthCheckDate: selDate,
                }));
                handleChange("HealthCheckDate", date);
              }}
              formatDate={japaneseDateConverter}
            />
            <SectionHeader title={Lbl_Personal_Info.OCCUPATION_INFO_LBL} />
            <Dropdown
              required
              label={Lbl_Personal_Info.JOB_TYPE}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.JOB_TYPE)}
              id="JobType"
              options={JOBTYPE_OPTIONS}
              onChange={(_, o) => handleChange("JobType", o?.text)}
              errorMessage={errors.JobType} />
            <Dropdown
              label={Lbl_Personal_Info.QUALIFICATIONS}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.QUALIFICATIONS)}
              id="Qualifications"
              multiSelect
              selectedKeys={selectedOptions}
              options={QUALIFICATION_OPTIONS}
              onChange={handleQualificationsChange}
            />
            <DatePicker
              label={Lbl_Personal_Info.QUALIFICATION_EXPIRY}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.QUALIFICATION_EXPIRY)}
              strings={japaneseStrings}
              value={selectedDate.QualificationExpiry || undefined}
              onSelectDate={(date) => {
                const selDate = date || null;
                setSelectedDate((prev) => ({
                  ...prev,
                  QualificationExpiry: selDate,
                }));
                handleChange("QualificationExpiry", date);
              }}
              formatDate={japaneseDateConverter}
            />
            <Dropdown
              label={Lbl_Personal_Info.QUALIFICATIONS}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.QUALIFICATIONS)}
              multiSelect
              options={QUALIFICATION_OPTIONS}
              selectedKeys={selectedOptions}
              onChange={handleQualificationChange}
            />
            {selectedQualification.map((taskKey) => (
              <Stack
                key={taskKey}
                tokens={{ childrenGap: 12 }}
                styles={{
                  root: {
                    border: "1px solid #ddd",
                    borderRadius: 8,
                    padding: 16,
                    marginBottom: 20,
                  },
                }}
              >
                <span style={{ fontWeight: 600 }}>
                  {QUALIFICATION_OPTIONS.find(o => o.key === taskKey)?.text}
                </span>

                <FileUpload
                  label={Lbl_Personal_Info.QUALIFICATION_PHOTO_LBL}
                  placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.QUALIFICATION_PHOTO_LBL)}
                  multiple={false}
                  onFileSelect={(files) => {
                    const file = files[0] || null;
                    setQualificationDate((prev) => ({
                      ...prev,
                      [taskKey]: { ...prev[taskKey], file },
                    }));
                  }}
                />
                <DatePicker
                  label={Lbl_Personal_Info.QUALIFICATION_EXPIRY}
                  placeholder={formatMessage(
                    Err_Common.REQUIRED_SELECT,
                    Lbl_Personal_Info.QUALIFICATION_EXPIRY
                  )}
                  strings={japaneseStrings}
                  value={selectedQualificationDate[taskKey]?.QualificationExpiry || undefined}
                  onSelectDate={(date) => {
                    const selDate = date || null;
                    setQualificationDate((prev) => ({
                      ...prev,
                      [taskKey]: { ...prev[taskKey], QualificationExpiry: selDate },
                    }));
                    handleChange("QualificationExpiry", date);
                  }}
                  formatDate={japaneseDateConverter}
                />
              </Stack>
            ))}
            <FileUpload
              label={Lbl_Personal_Info.FACE_PHOTOS_LBL}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.FACE_PHOTOS_LBL)} />
            <Stack horizontal className="buttonallign" tokens={{ childrenGap: 10 }}>
              <PrimaryButton
                className="custom-primary-button"
                text={isBulkEdit ? (Lbl_Common.SAVE) : (Lbl_Common.REGISTER)}
                onClick={() => {
                  if (validateAndSubmit()) {
                    setLoading(true);
                    handleSave();
                  }
                }}
              />
              <PrimaryButton className="cancel-button" text={Lbl_Common.CANCEL} onClick={goBack} />
            </Stack>
          </Stack>
        </div>
      </div>
    </div>
  );
};